module.exports = __webpack_public_path__ + "media/images/gallery/constellations/andromeda/and_dir-8359d2a95396be61c46095d6c1e3bf62.gif";